import {
  ProductAttributes,
  ProductThumbnail,
  Tag,
  Text
} from '@cencosud-cencommerce/paris-uikit';

import { SoldBy } from '@/Pages/BuyNowPage/PaymentAndShipping/partials/ProductList';
import type { ProductItemProps } from '@/Pages/BuyNowPage/PaymentAndShipping/partials/ProductList/interfaces';

const LABEL_PRESALE = 'Preventa';

export const ProductItem = ({ product }: { product: ProductItemProps }) => {
  if (!product) return null;

  return (
    <div
      data-testid={'product-item'}
      className="co-flex co-gap-3 co-p-3 co-pb-0 tablet_w:co-p-6 tablet_w:co-pb-4"
    >
      <ProductThumbnail src={product?.imageUrl} />

      <div className="co-grid co-grid-cols co-w-full co-gap-3">
        <div className="co-flex co-justify-between co-gap-3 co-min-w-0 co-h-[45px]">
          <div className="co-flex co-flex-col co-min-w-0 co-gap-1">
            <div className="co-overflow-hidden co-text-ellipsis co-whitespace-nowrap co-flex-shrink-0">
              <Text variant="body2" weight={600}>
                {product?.name}
              </Text>
            </div>
            <div>
              <SoldBy {...product} />
            </div>
            {product?.isPreSale && (
              <div>
                <Tag variant="information" iconName="order">
                  {LABEL_PRESALE}
                </Tag>
              </div>
            )}
          </div>
        </div>

        <div className="co-flex co-justify-between co-min-w-0 ">
          <ProductAttributes specs={product?.specs} className="" />
        </div>
      </div>
    </div>
  );
};

export default ProductItem;
